import type { OrderOptions } from '@/shared/lib';
import type { DirectorySearchCriterion } from '../model/directorySearch.utils';

export const ORDER_OPTIONS: OrderOptions[] = [
  { label: 'Por mais recente', sort: 'createdAt', order: 'desc' },
  { label: 'Por mais antigo', sort: 'createdAt', order: 'asc' },
  { label: 'Por ordem alfabética crescente', sort: 'name', order: 'asc' },
  { label: 'Por ordem alfabética decrescente', sort: 'name', order: 'desc' },
];

export const SEARCH_CRITERION_OPTIONS = [
  { id: 'module', name: 'Módulo' },
  { id: 'folder', name: 'Pasta' },
  { id: 'title', name: 'Título' },
  { id: 'prefix', name: 'Prefixo' },
] satisfies { id: DirectorySearchCriterion; name: string }[];
